import { render, staticRenderFns } from "./GiftReportTable.vue?vue&type=template&id=41395610&scoped=true&"
import script from "./GiftReportTable.vue?vue&type=script&lang=js&"
export * from "./GiftReportTable.vue?vue&type=script&lang=js&"
import style0 from "./GiftReportTable.vue?vue&type=style&index=0&id=41395610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41395610",
  null
  
)

export default component.exports